import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";
import toast from "react-hot-toast";

const postWeekMenu = async (weekData) => {
  const response = await axios.post(
    `${WiMuleSQL}/api/LunchMenu/PostWeekMenu`,
    weekData
  );
  return response.data;
};

export const usePostWeekMenu = (options = {}) =>
  useMutation({
    mutationFn: postWeekMenu,
    onSuccess: (data, variables, context) => {
      toast.success(data.message || "Week menu saved successfully.");
      options.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to save week menu.";
      toast.error(message);
      options.onError?.(error, variables, context);
    },
    ...options,
  });
